import React, { FC } from 'react';

import Image from 'next/image';

interface ImageProps {
  height?: number | string;
  width?: number | string;
}

export const ImageVestaLogo: FC<ImageProps & { small?: boolean }> = ({ small, height = 34, width = 34 }) => (
  <Image
    src={small ? '/v2/assets/VSTA-dark.svg' : '/v2/vesta-logo-long.svg'}
    width={small ? width : '180px'}
    height={small ? height : '16px'}
  />
);

export const ImageVestaVault: FC<ImageProps> = ({ height = 750, width = 750 }) => (
  <Image src={'/img/landing/vesta_vault 1.svg'} width={width} height={height} />
);

export const ImageBorrow: FC<ImageProps> = ({ height = 500, width = 630 }) => (
  <Image src={'/img/cards/mint.webp'} width={width} height={height} />
);

export const ImageSwap: FC<ImageProps> = ({ height = 500, width = 630 }) => (
  <Image src={'/img/cards/swap.webp'} width={width} height={height} />
);

export const ImageStabilityPool: FC<ImageProps> = ({ height = 600, width = 950 }) => (
  <Image src={'/img/cards/stability_staking.png'} width={width} height={height} />
);

export const ImageBProtocolLogo: FC<ImageProps> = ({ height = 26, width = 90 }) => (
  <Image src="/img/bprotocol.svg" width={width} height={height} />
);

export const ImageVectorGlobe: FC<ImageProps> = ({ height = 150, width = 150 }) => (
  <Image src="/img/vectorGlobe.svg" height={height} width={width} />
);

export const ImageNotForgingVKey: FC<ImageProps> = ({ height = 477.6, width = 829 }) => (
  <Image src="/img/nft/not-forging.png" height={height} width={width} />
);

export const ImageForgingVKey: FC<ImageProps & { tier: 0 | 1 | 2 }> = ({
  tier,
  height = 477.6,
  width = 829,
}) => {
  switch (tier) {
    case 1:
      return <Image src="/img/nft/tier-2-forging.png" height={height} width={width} />;
    case 2:
      return <Image src="/img/nft/tier-3-forging.png" height={height} width={width} />;
    default:
      return <Image src="/img/nft/tier-1-forging.png" height={height} width={width} />;
  }
};

export const ImageForgedVKey: FC<ImageProps & { tier: 0 | 1 | 2 }> = ({
  height = 477.6,
  width = 829,
  tier,
}) => {
  switch (tier) {
    case 1:
      return <Image src="/img/nft/tier-2-forged.png" height={height} width={width} />;
    case 2:
      return <Image src="/img/nft/tier-3-forged.png" height={height} width={width} />;
    default:
      return <Image src="/img/nft/tier-1-forged.png" height={height} width={width} />;
  }
};
export const ImageVKeyThumb: FC<ImageProps & { tier: 0 | 1 | 2 }> = ({ height = 290, width = 290, tier }) => {
  switch (tier) {
    case 1:
      return <Image src="/img/nft/tier-2-thumbnail.jpg" height={height} width={width} />;
    case 2:
      return <Image src="/img/nft/tier-3-thumbnail.jpg" height={height} width={width} />;
    default:
      return <Image src="/img/nft/tier-1-thumbnail.jpg" height={height} width={width} />;
  }
};
